import { number, string, oneOfType, node, bool, shape, object } from "prop-types";
import { Grid } from "@material-ui/core";
import { useSortable } from "@dnd-kit/react/sortable";
import { RestrictToElement, RestrictToWindow } from "@dnd-kit/dom/modifiers";
import useStyle from "./SortableItem.style";
import classnames from "classnames";
import { DragHandle } from "@components";

export const SortableItem = ({
  id,
  index,
  children,
  useDragHandle,
  dragHandleProps,
  className,
  style,
  restrictToWindow,
  containerElement,
  disabled,
  wrap="nowrap",
  alignItems="center",
  justifyContent="flex-start",
}) => {
  const classes = useStyle();
  
  const {
    ref,
    handleRef,
    isDragging
  } = useSortable({
    id, index,
    disabled,
    modifiers: [
      restrictToWindow ? RestrictToWindow : RestrictToElement.configure({ element: containerElement }),
    ]
  });
  
  return (
    <Grid
      ref={ref}
      item container
      wrap={wrap}
      alignItems={alignItems}
      justifyContent={justifyContent}
      className={classnames(
        !isDragging && classes.static,
        !useDragHandle && "cursor-grab",
        useDragHandle && "relative",
        className,
      )}
      style={style}
    >
      {
        useDragHandle &&
        <DragHandle
          absolute showOnHover
          ref={handleRef}
          { ...dragHandleProps }
          style={{
            left: -24,
            ...(dragHandleProps?.style || {})
          }}
        />
      }
      { children }
    </Grid>
  )
}

SortableItem.propTypes = {
  id: oneOfType([string, number]).isRequired,
  index: number.isRequired,
  children: node.isRequired,
  containerElement: object,
  // overlay: bool,
  disabled: bool,
  useDragHandle: bool,
  dragHandleProps: shape(DragHandle.propTypes),
  className: string,
  style: object,
  wrap: string,
  alignItems: string,
  justifyContent: string,
  restrictToWindow: bool,
}